import api from './api';

const BASE_URL = '/api/v1/admin/referral-reports';

const cleanParams = (params) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== '' && value !== null && value !== undefined)
);

export const referralReportService = {
  getSummary: (params) => api.get(`${BASE_URL}/summary`, { params: cleanParams(params) }),
  getDetailed: (params) => api.get(`${BASE_URL}/detailed`, { params: cleanParams(params) }),
  getOptions: () => api.get(`${BASE_URL}/options`),
  suspendCode: (referralCodeId, suspendReason) => api.patch(
    `/api/v1/admin/referral-codes/${referralCodeId}/suspend`,
    { suspend_reason: suspendReason }
  ),
  export: (params) => api.get(`${BASE_URL}/export`, {
    params: cleanParams(params),
    responseType: 'blob',
  }),
};
